export default __webpack_public_path__ + "static/media/icon-email-marketing-delivered.6e3d33ee.svg";